import { Typography, styled } from '@mui/material';

const StyledMoreProfileSubtitle = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(18)
}));

export default StyledMoreProfileSubtitle;
